<script>
import { defineComponent } from '@vue/composition-api'
import { WarningServiceProxy,MaintainRecordServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'
import { dayjsFormat } from '@/utils'

const wsp = new WarningServiceProxy()
const mrsp = new MaintainRecordServiceProxy()
const columns = [
  { title: 'actions', ellipsis: true, scopedSlots: { customRender: 'action' }, width: 100  },
  { title: 'page_plan_maintenance_task_number', ellipsis: true, dataIndex: 'planCode', width: 150  },
  { title: 'page_plan_maintenance_application_form_status', ellipsis: true, dataIndex: 'recordStatusName', width: 150  },
  { title: 'page_tpm_check_device_code', ellipsis: true, dataIndex: 'deviceCode', width: 150  },
  { title: 'page_tpm_check_device_name', ellipsis: true, dataIndex: 'deviceName', width: 150  },
  { title: 'page_business_maintenance', ellipsis: true, dataIndex: 'projectName', width: 150  },
  { 
    title: 'page_plan_maintenance_maintenance_start_time',
    dataIndex: 'startTime',
    ellipsis: true,
    customRender: time => time ? dayjsFormat(time) : "",
    width: 150 
  },
  {
    title: 'page_plan_maintenance_maintenance_completion_time',
    dataIndex: 'endTime',
    ellipsis: true,
    customRender: time => time ? dayjsFormat(time) : "",
    width: 150
  },
  { title: 'page_plan_maintenance_whether_it_is_postponed_or_not', ellipsis: true, dataIndex: 'isDelayName', width: 150 },
  { title: 'page_plan_maintenance_person_in_charge_of_maintenance', ellipsis: true, dataIndex: 'maintainUserName', width: 150 },
]
export default defineComponent({
  components: {
  },
  data(){
    return {
      pagination: {
        current: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: []
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  created(){
    this.pagination.current = 1
    this.pagination.pageSize = 10
    this.getData()
  },
  methods:{
    getData(){
      this.loading = true
      this.dataSource = []
      wsp.pageMaintainPlanConfirmed(this.pagination.current,this.pagination.pageSize).then(res =>{
        this.dataSource = res.records
        this.total = res.total
        this.loading = false
      }).catch(() =>{
        this.loading = false
      })
    },
    openEditModal(value){
      console.log(value)
      mrsp.confirmMaintainRecord(value.id).then(() => {
        this.$message.success(this.$t('page_plan_maintenance_successful_execution'))
        this.pagination.current = 1
        this.getData()
      })
    },
    showTotal(total) {
      return (this.$t('Total…items')).replace('{0}', total)
    },
    handleTableChange(current,size){
      this.pagination.current = current
      this.getData()
    }
  },
})
</script>

<template>
  <div style="position: relative;padding-bottom: 40px;">
    <ml-table bordered :data-source="dataSource" :columns="columns" :scroll="{x: 1450}">
      <template #action="value,records">
        <a @click="openEditModal(records)">{{ $t('page_workstation_maintain_sure') }}</a>
      </template>
    </ml-table>
    <a-pagination
      style="position:absolute;bottom: 4px;right: 20px"
      :show-total="total => `${showTotal(total)}`"
      :current="pagination.current"
      :pageSize="pagination.pageSize"
      :total="total"
      @change="handleTableChange"
    />
  </div>
</template>

